export default __webpack_public_path__ + "static/media/live-casino-cat.ebe724bb.webp";